<template>
  <div class="LiveHighlights subWrapper">
    <!-- logo + menu -->
    <LogoMenu v-if="ismobile" :loadmounted="ismobile" :active-name="menuName" />
    <!-- 现场花絮 -->
    <div class="sub_contBox" :class="sflag ? 'Live-menu' : ''" v-if="!ismobile" @scroll="scrollFn($event)">
      <div class="contbox_scroll">
        <!-- logo + menu -->
        <LogoMenu :loadmounted="ismobile" :active-name="menuName" />
        <!-- 内容 -->
        <div class="contbox_top">
          <!-- 现场花絮 txt -->
          <div class="sub_title"><img src="../assets/image/right_arrow.png" /><span>{{ name }}</span><img src="../assets/image/left_arrow.png" /></div>
          <!-- 图片 -->
          <img src="../assets/image/live_img.png" class="live-img" />
          <!-- 文字 -->
          <p class="live-txt">2021中国（上海）国际隧道工程研讨会圆满闭幕。这是一场超高规格、超高水准的学术盛会；这是一场立意高远、内容丰盛的思想盛宴。为期2天的会议，共设置1个主旨论坛，6个主题论坛，来自中国、日本、意大利、奥地利、巴西等多个国家行业人士通过线上线下的模式共襄盛举，通过近100个学术报告共同探讨“城市复杂环境下隧道工程的挑战与创新”，为城市地下空间建设发展汇聚创新力量与智慧方案。接下来，就请随着摄影师的镜头一起回顾精彩瞬间，定格美好回忆吧！</p>
          <!-- 论坛主题 -->
          <ul class="theme-box">
            <li v-for="(item, index) in themeArr" :key="index" :class="themeNowId == item.id ? 'theme-active' : ''" @click="changeThemeFn(item.id)">{{ item.name }}</li>
          </ul>
          <!-- 内容 -->
          <div class="LiveHighlights_cont sub_cont">
            <!--预览-->
            <vue-preview :slides="setPreview()" class="preview"></vue-preview>
          </div>
          <!-- 论坛二维码 -->
          <p class="theme-ewm-txt">更多精彩花絮，请扫码查看！</p>
          <p class="theme-ewm"><img :src="ewmSrc" /></p>
        </div>
        <!-- 底部信息 -->
        <Foot />
      </div>
    </div>
    <!-- pc -->
    <div class="sub_contBox" v-else>
      <!-- 面包屑 -->
      <div class="Breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主体 -->
      <div class="content_box">
        <div class="live-theme-box">
          <!-- 图片 -->
          <img src="../assets/image/xchx2018.jpg" class="live-img" />
          <!-- 文字 -->
          <p class="live-txt">2021中国（上海）国际隧道工程研讨会圆满闭幕。这是一场超高规格、超高水准的学术盛会；这是一场立意高远、内容丰盛的思想盛宴。为期2天的会议，共设置1个主旨论坛，6个主题论坛，来自中国、日本、意大利、奥地利、巴西等多个国家行业人士通过线上线下的模式共襄盛举，通过近100个学术报告共同探讨“城市复杂环境下隧道工程的挑战与创新”，为城市地下空间建设发展汇聚创新力量与智慧方案。接下来，就请随着摄影师的镜头一起回顾精彩瞬间，定格美好回忆吧！</p>
          <!-- 分割线 -->
          <p class="live-line"></p>
          <!-- 论坛主题 -->
          <ul class="theme-box">
            <li v-for="(item, index) in themeArr" :key="index" :class="themeNowId == item.id ? 'theme-active' : ''" @click="changeThemeFn(item.id)">{{ item.name }}</li>
          </ul>
          <!-- 图片显示 -->
          <ul class="theme-pic">
            <li v-for="(item, index) in details" :key="index" @click="ToGoDetailFn(index)"><img :src="item.imagePath" /><p class="Linebreak">现场花絮</p></li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <Foot v-if="ismobile" />
  </div>
</template>

<script>
  import LogoMenu from '../components/LogoMenu.vue'
  import { AccessRecordsApi,LiveHighlightsApi } from '../request/api.js'
  import Foot from '../components/Footer.vue'
  export default {
    name: "LiveHighlights",
    data() {
      return {
        name: '现场花絮',
        ismobile: false, // false:pc true:mobile
        menuName: '',
        themeArr: [{ name: '主论坛', id: 19, ewmSrc: '../../static/img/theme-0.png' },{ name: '主题论坛一', id: 20, ewmSrc: '../../static/img/theme-1.png' },{ name: '主题论坛二', id: 21, ewmSrc: '../../static/img/theme-2.png' },{ name: '主题论坛三', id: 22, ewmSrc: '../../static/img/theme-3.png' },{ name: '主题论坛四', id: 23, ewmSrc: '../../static/img/theme-4.png' },{ name: '主题论坛五', id: 24, ewmSrc: '../../static/img/theme-5.png' },{ name: '主题论坛六', id: 25, ewmSrc: '../../static/img/theme-6.png' }],
        themeNowId: 19,
        themeDataAll: [],  // 全部主题的图
        details: [],  // 当前主题的图
        sflag: false,  // 是否滚动
        ewmSrc: '../../static/img/theme-0.png'
      }
    },
    created() {
      let wid = window.innerWidth;
      this.menuName = this.$route.query.name;
      if (wid >= 320 && wid <= 1024) {
        this.ismobile = false;
      } else {
        this.ismobile = true;
      }
    },
    mounted() {
      this.AccessRecordsFn();
      this.GetLiveDataFn();
    },
    methods: {
      // 滚动后 使导航浮动
      scrollFn(e){
        if(e.target.scrollTop > 0){
          this.sflag = true;
        }else{
          this.sflag = false;
        }
      },
      // 获取数据
      GetLiveDataFn(){
        LiveHighlightsApi({
          Sorting: 'displayIndex asc,creationDate asc',
          ChildrenSorting: 'displayIndex asc,creationDate asc'
        }).then(res => {
          this.themeDataAll = res.seminarSubTopics;
          this.details = res.seminarSubTopics[0].seminarNewsList;
        });
      },
      //给预览图设置参数
      setPreview() {
        this.details.forEach(img => {
          img.src = img.imagePath;
          img.msrc = img.imagePath;
          img.alt = '现场花絮';
          img.title = '现场花絮';
          img.w = window.innerWidth; //这是大图的宽
          img.h = 279;
        })
        return this.details;
      },
      // 切换论坛
      changeThemeFn(id){
        let flag = false;
        this.themeNowId = id;
        for(let i=0;i<this.themeDataAll.length;i++){
          if(id == this.themeDataAll[i].id){
            this.details = this.themeDataAll[i].seminarNewsList;
            this.ewmSrc = this.themeArr[i].ewmSrc;
            flag = true;
            return;
          }

          if(i == this.themeDataAll.length - 1 && !flag){
            this.details = [];
            this.ewmSrc = '';
          }
        }
      },
      // 去详情页
      ToGoDetailFn(ind){
        this.$router.push({ path: '/liveDetails',query: { id: this.themeNowId, index: ind } });
      },
      // 访问记录
      AccessRecordsFn() {
        AccessRecordsApi({
          seminarTopicId: 12
        });
      }
    },
    components: {
      LogoMenu,
      Foot
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .live-img{
      width: 100%;
      height: auto;
    }

    .live-txt{
      line-height: 30px;
      text-align: left;
      text-indent: 2em;
      margin-bottom: 30px;
      margin-top: 20px;
      font-size: 17px;
    }

    .live-line{
      height: 1px;
      background-color: #eaeaea;
    }

    .theme-box{
      display: flex;
      border: 1px solid #1058bb;
      margin: 30px 0 15px;
    }

    .theme-box li{
      width: 100%;
      cursor: pointer;
      border-left: 1px solid #1058bb;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
    }

    .theme-box li:first-child{
      border-left: 0;
    }

    .theme-active{
      background-color: #1058bb;
      color: #FFFFFF;
    }

    .theme-pic{
      display: flex;
      flex-wrap: wrap;
    }

    .theme-pic li{
      width: 19.2%;
      margin: 15px 1% 0 0;
      border: 1px solid #ccc;
      cursor: pointer;
    }

    .theme-pic li:nth-child(5n){
      margin-right: 0;
    }

    .theme-pic li img{
      width: 100%;
      height: 145px;
    }

    .theme-pic li p{
      padding: 0 9px;
      line-height: 26px;
      max-height: 52px;
      font-size: 14px;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .LiveHighlights{
      position: relative;
      /* padding: 1.2rem 0 0; */
      overflow: hidden;
    }

    .Live-menu .sub_contBox{
      padding: 1rem 0 0;
    }

    .live-img{
      width: 100%;
      height: auto;
    }

    .live-txt{
      font-size: .28rem;
      line-height: .48rem;
      text-indent: .56rem;
    }

    .theme-box{
      display: flex;
      flex-wrap: wrap;
      margin: .2rem 0 .25rem;
    }

    .theme-box li{
      font-size: .28rem;
      line-height: .48rem;
      text-align: center;
      width: 33%;
      margin: 4px .5% 0 0;
      border: solid 1px #1058bb;
    }

    .theme-box li:first-child{
      width: 100%;
      margin: 0;
    }

    .theme-box li:nth-child(4),.theme-box li:nth-child(7){
      margin-right: 0;
    }

    .theme-active{
      background-color: #1058bb;
      color: #FFFFFF;
    }

    .LiveHighlights_cont{
      min-height: 150px;
    }

	.theme-ewm-txt{
    font-size: 14px;
    text-align: center;
	}

    .theme-ewm{
      text-align: center;
      margin-top: 10px;
    }

    .theme-ewm img{
      width: 60%;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/LiveHighlights.vue